import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.5 15.902a5.147 5.147 0 115.588 0M11.294 1.284v2.059M1 11.578h2.059M19.53 11.578h2.058M3.574 3.857l1.544 1.545M17.47 5.402l1.545-1.545M1 15.902h21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);